import React from 'react';
import face from '../assets/images/circle-cropped.png';
import '../styles/about.css'

function AboutPage (props) {

  return (
    <div className="about-container">
      <div className="title">
        About
          </div>
      <img className="face" src={face} alt="profile"></img>


      <p>Hello, my name is David. I'm a full stack engineer with experience in Javascript, HTML, CSS, React, Redux,  Node, Angular, Express, Koa, GraphQL, MongoDB and PostgreSQL .</p>

      <p>I am a fast learner and a driven developer, who likes to be challenged and work on tight schedules. I enjoy developing solutions and embracing new technologies.</p>

      <p>I recently made the decision to move on from my career as a chartered accountant because I felt the need to have a more meaningful impact on the world. I want to pursue a career that allows
me to build solutions to real world problems and really make a difference.</p>

      <p>I love to travel and I’ve spent several years backpacking across every continent. It has allowed me to discover other perspectives on the world and learn valuable life lessons
. I also love skiing, hiking, camping and anything that allows me to enjoy the beauty of nature.</p>

    </div>
  );

}

export default AboutPage;